import { createContext } from "react"
import type { ChatMessages } from "@/reducers/messagesSlice"

// An isolated archive window can display a different room from the active chat.
export const ArchivedChatContext = createContext<
  | { chatJid: string; chatMessages: ChatMessages; mediaSource: string }
  | undefined
>(undefined)
